/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gender_Female6Inputs */

const en__field__enum_gender_female6 = /** @type {(inputs: _Field__Enum_Gender_Female6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const de__field__enum_gender_female6 = /** @type {(inputs: _Field__Enum_Gender_Female6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiblich`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {_Field__Enum_Gender_Female6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gender_female6 = /** @type {((inputs?: _Field__Enum_Gender_Female6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gender_Female6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gender_female6(inputs)
	return de__field__enum_gender_female6(inputs)
});
export { _field__enum_gender_female6 as "_field__enum_gender_FEMALE" }